















































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { SyncService } from "@/services/Sync.service.ts";
import { SyncTableItem } from "@/models/SyncTable.ts";
import { AccountService } from "@/services/account.service.ts";
import { Notification } from "element-ui";
import { Action, Getter } from "vuex-class";
import { StompClient } from "@/services/StompClient";

export interface TableData {
  groupCd?: string;
  dbNm?: string;
  statusSync?: number;
}

@Component
export default class ManualSync extends Vue {
  @Prop({ default: "" })
  title: string;
  public syncService = new SyncService();
  public accountService = new AccountService();

  loading: boolean = true;
  loadingBtn: boolean = false;
  socketResponse: any = { success: "", error: "" };
  mockSyncDone: boolean = false;
  mockSyncProgress: number = 0;
  mockSyncIncrement: number = 1;
  mockSyncTreshold: number = 95;
  tableList: SyncTableItem[] = [];
  showManageModal: boolean = false;
  showWarningModal: boolean = false;
  groupList: string[] = [];
  addGroupCd: string = "";
  addDbName: string = "";
  dbAdding: boolean = false;

  public tableDataList: TableData[] = [];

  public form: any = {
    tableSelected: ""
  };
  syncSubscription: any = null;

  @Action("connect", { namespace: "Socket" })
  connectSocket: any;
  @Getter("socket", { namespace: "Socket" })
  socket: StompClient;

  created() {
    this.syncService.getSyncTableList().then((response: SyncTableItem[]) => {
      if (response) {
        this.tableList = response.map((item: SyncTableItem) => {
          return {
            ...item,
            syncing: false,
            success: -1,
            disabled: false
          };
        });
      } else {
        alert("システムエラーが発生しました。");
      }
      this.loading = false;
    });
  }

  mounted() {
    this.getGroupDataList().then(res => {
      this.connectSocket(this.onConnect);
    });
    this.getTableDataList();
  }

  public async getTableDataList() {
    const result = await this.syncService.getTables();
    if (result) {
      this.$set(this, "tableDataList", result);
    }
  }

  async firstSync() {
    this.loadingBtn = true;
    this.toggleTableSyncButtons(true);
    this.runMockSync();
    const { result, error } = await this.syncService.syncTable({
      schema: this.form.tableSelected
    });
  }

  toggleTableSyncButtons(disabled: boolean) {
    this.tableList = this.tableList.map((item: SyncTableItem) => {
      return {
        ...item,
        disabled
      };
    });
  }

  runMockSync() {
    this.mockSyncDone = false;
    const intv = setInterval(() => {
      this.mockSyncProgress = this.getMockSyncProgress(this.socketResponse);
      if (this.mockSyncProgress < 0) {
        this.onMockSyncFailed();
        clearInterval(intv);
      } else if (this.mockSyncProgress === 100) {
        // Show success progress bar for 2 seconds, then hide it
        setTimeout(() => {
          this.onMockSyncSuccess();
        }, 2000);
        clearInterval(intv);
      }
    }, 500);
  }

  getMockSyncProgress(socketResponse: any) {
    const { success, error } = socketResponse;
    if (error) {
      return -1;
    }
    if (success) {
      return 100;
    }
    if (this.mockSyncProgress >= this.mockSyncTreshold) {
      return this.mockSyncTreshold;
    }
    return this.mockSyncProgress + this.mockSyncIncrement;
  }

  onMockSyncSuccess() {
    this.$notify({
      title: "Success",
      message: this.form.tableSelected + " data has been synced",
      type: "success",
      customClass: "txt-left"
    });
    this.resetMockSync();
  }

  onMockSyncFailed() {
    alert("システムエラーが発生しました。");
    this.resetMockSync();
  }

  resetMockSync() {
    this.loadingBtn = false;
    this.toggleTableSyncButtons(false);
    this.socketResponse = { success: "", error: "" };
    this.mockSyncDone = true;
    this.mockSyncProgress = 0;
  }

  async onSync(item: SyncTableItem) {
    item.success = -1;
    item.syncing = true;
    const { result, error } = await this.syncService.syncTable({
      numSync: item.numSync
    });
    if (result) {
      item.success = 1;
    } else {
      item.success = 0;
      alert("システムエラーが発生しました。");
    }
    item.syncing = false;
  }

  public async getGroupDataList() {
    const response = await this.accountService.getGroups();
    if (response && response.data) {
      this.groupList = response.data.map((item: any) => item.groupCd);
      this.form.groupCd = response.groupCd || "";
      this.form.shatenCd = response.shatenCd || "";
      this.form.kyotenCd = localStorage.getItem("kyotenCd");
    }
    return response;
  }

  onConnect() {
    if (this.socket.isConnected()) {
      this.syncSubscription = this.socket.client.subscribe(
        `/connect/sync/${this.form.groupCd}${this.form.shatenCd}${this.form.kyotenCd}/completed`,
        this.onSyncConnect
      );
    }
  }

  onSyncConnect(response: any) {
    const { success = "", error = "" } = JSON.parse(response.body);
    this.socketResponse = { success, error };
  }

  async checkAddDuplicate() {
    const isExist = this.tableDataList.find(item => item.groupCd === this.addGroupCd && item.dbNm === this.addDbName);
    if (isExist) {
      return (this.showWarningModal = true);
    }

    this.dbAdding = true;
    const { result, error } = await this.syncService.addDbForSync({ groupCd: this.addGroupCd, dbNm: this.addDbName });
    await this.getTableDataList();
    this.dbAdding = false;
  }

  onManageModalClosed() {
    this.addGroupCd = "";
    this.addDbName = "";
  }

  get progressBarStatus() {
    const { success, error } = this.socketResponse;
    if (error) {
      return "exception";
    }
    if (success) {
      return "success";
    }
    return null;
  }
}
